import * as React from "react";
import {ReadAndWriteContext} from "../../../providers/ReadAndWriteProvider";
import {CurrentConfigurationTable} from "../../widgets/CurrentConfigurationTable";
import {getEditingSettings} from "../../ReadAndWrite/utils";
import {LastCampaignInfo} from "../../widgets/LastCampaignInfo";
import {useCurrentSettingsUpdateResult} from "../../data/hooks/ReadAndWriteControllerHooks";

interface CurrentConfigurationPageProps {

}

export const CurrentConfigurationPage: React.FC<CurrentConfigurationPageProps> = () => {
    const {
        deviceSlaveSettings,
        availableRegisters,
        IsRWSupportedCheck,
        AppTranslations,
        deviceGuid,
        hasPermissionsToEditSettings
    } = React.useContext(
        ReadAndWriteContext);
    const currentSettingsUpdateResult = useCurrentSettingsUpdateResult(deviceGuid);

    const deviceSettings = deviceSlaveSettings?.data?.settings?.settings ?? [];
    const deviceSlaveAvailableRegisters = availableRegisters?.data ?? [];
    const settings = getEditingSettings(deviceSettings, deviceSlaveAvailableRegisters);

    const [canEdit, setCanEdit] = React.useState<boolean>(false)
    const [errorMessage, setErrorMessage] = React.useState<string>("")


    React.useEffect(() => {
        if (!IsRWSupportedCheck.isLoading && !deviceSlaveSettings.isLoading) {
            const availableData = IsRWSupportedCheck?.data
            const slaveData = deviceSlaveSettings?.data

            if (!IsRWSupportedCheck?.data.editable) {
                setErrorMessage(IsRWSupportedCheck?.data.errorMessage)
            } else if (slaveData.updating || slaveData.validating) {
                setErrorMessage(
                    AppTranslations.readAndWrite.functionNotAvailable + " - " + AppTranslations.readAndWrite.updatingConfiguration.toLowerCase())
            }

            setCanEdit(
                availableData?.editable && !slaveData.updating && !slaveData.validating)
        }
    }, [IsRWSupportedCheck.isLoading, deviceSlaveSettings.isLoading])

    return (
        <div className={"settings-main-container"}>
            <LastCampaignInfo {...currentSettingsUpdateResult}/>
            <CurrentConfigurationTable
                settings={settings}
                isLoading={deviceSlaveSettings.isLoading || availableRegisters.isLoading}
                canEdit={canEdit}
                errorMessage={errorMessage}
                showEditButton={hasPermissionsToEditSettings}
            />
        </div>
    );
};

